module.exports = __webpack_public_path__ + "static/media/013 I GUERRA M_Giornale di reggio.ab93e920.svg";